import React from "react";
import { Document, Page, Text, View, StyleSheet ,Image} from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";

const styles = StyleSheet.create({
  page: { padding: 30, fontSize: 12, fontFamily: "Helvetica", color: "#101828" },
  heading: {
    textAlign: "center",
    fontSize: 18,
    fontWeight: "bold",
    marginBottom: 20,
    color: "#003149",
  },
  recordGroup: {
    marginBottom: 12,
    paddingBottom: 8,
    borderBottomWidth: 1,
    borderBottomColor: "#ccc",
    borderBottomStyle: "solid",
  },
  row: { flexDirection: "row", justifyContent: "space-between", marginBottom: 6 },
  label: { color: "#344054", fontWeight: "bold" },
  value: { color: "#101828" },
});

const ExportHistoryPDF = ({ data ,logo
}) => {
  const { t } = useTranslation();

  return (
    <Document>
      <Page size="A4" style={styles.page}>
            {logo && (
          <Image
            src={logo}
            style={{ width: 120, alignSelf: "center", marginBottom: 10 }}
          />
        )}
        <Text style={styles.heading}>
          {t("documentHistory.title")}
        </Text>

        {data.map((row, i) => (
          <View key={i} style={styles.recordGroup}>
            <View style={styles.row}>
              <Text style={styles.label}>{t("documentHistory.table.id")}:</Text>
              <Text style={styles.value}>{row.id}</Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>{t("documentHistory.table.type")}:</Text>
              <Text style={styles.value}>{row.documentType}</Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>{t("documentHistory.table.worker_name")}:</Text>
              <Text style={styles.value}>{row.workerName}</Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>{t("documentHistory.table.generated_by")}:</Text>
              <Text style={styles.value}>{row.generatedBy}</Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>{t("documentHistory.table.period")}:</Text>
              <Text style={styles.value}>{row.period}</Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>{t("documentHistory.table.status")}:</Text>
              <Text style={styles.value}>{row.status}</Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>{t("documentHistory.table.created_at")}:</Text>
              <Text style={styles.value}>{row.createdAt}</Text>
            </View>
          </View>
        ))}
      </Page>
    </Document>
  );
};

export default ExportHistoryPDF;